<div class="restriction-modal">
  <div class="restriction-modal-dialog">
    <div class="restriction-modal-content">
      <div class="restriction-modal-content__header">Restrictions</div>

      <!-- EDIT -->
      <!-- Clicking outside intentionally does NOT dismiss this modal: it holds
           unsaved input, so the only ways out are Cancel / Save (or Remove). Both
           states are kept in the DOM and toggled with [hidden] so the two-step
           edit -> confirm swap never detaches a button mid-click. -->
      <div [hidden]="confirmingRemoval">
        <div class="restriction-modal-content__body">
          <div class="restriction-form-textarea">
            <textarea placeholder="Example: No US Sales" [formControl]="newRestriction"></textarea>
          </div>
        </div>
        <div class="restriction-modal-content__footer">
          <button type="button" class="restriction-form-button cancel" (click)="close()">Cancel</button>
          <button type="button" class="restriction-form-button save" (click)="save()">Save</button>
        </div>
      </div>

      <!-- CONFIRM REMOVAL -->
      <div [hidden]="!confirmingRemoval">
        <div class="restriction-modal-content__body">
          <p class="restriction-remove-warning">
            You're about to remove the restrictions from this item. Do you want to continue?
          </p>
        </div>
        <div class="restriction-modal-content__footer">
          <button type="button" class="restriction-form-button cancel" (click)="cancelRemoval()">Cancel</button>
          <button type="button" class="restriction-form-button remove" (click)="patchRestriction()">Remove</button>
        </div>
      </div>
    </div>
  </div>
</div>
